import { type Resource, createContext, useContext } from "solid-js";
import type { List } from "../../types/list";

interface LinksContext {
	list: Resource<List>;
}

export const LinksContext = createContext<LinksContext>(undefined, { name: "LinksContext" });

export function useListLinksWidget() {
	const context = useContext(LinksContext);

	if (!context) {
		throw new Error("useLinksWidget must be used within a LinksProvider");
	}

	return context;
}
